var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loading
    ? _c("Loading")
    : _c("Box", { staticClass: "responder", attrs: { padding: 5 } }, [
        _vm.error
          ? _c("div", { staticClass: "error" }, [
              _vm._v("Error executing request")
            ])
          : _vm._e(),
        !_vm.error && _vm.tokenData
          ? _c("div", { staticClass: "success" }, [
              _vm._v(" " + _vm._s(_vm.tokenData.userName) + " have been "),
              !_vm.tokenData.approved
                ? _c("span", { staticClass: "deny" }, [
                    _vm._v("denied from being a manager")
                  ])
                : _vm._e(),
              _vm.tokenData.type === "Primary"
                ? _c("span", { staticClass: "approve" }, [
                    _vm._v("approved as primary manager")
                  ])
                : _vm._e(),
              _vm.tokenData.type === "Secondary"
                ? _c("span", { staticClass: "approve" }, [
                    _vm._v("approved as secondary manager")
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }